import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import cookie from 'react-cookie';
import Link from '../common/Link';

Modal.setAppElement('#app');

export default class ForthcomingModal extends React.Component {
  static propTypes = {
    developmentId: PropTypes.number.isRequired,
    development: PropTypes.string.isRequired,
    alreadySubmitted: PropTypes.bool.isRequired,
    error: PropTypes.string,
    loading: PropTypes.bool,
    onSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  static defaultProps = {
    error: '',
    loading: false,
  };

  state = {
    privacy: false,
    save: true,
  };

  handleChange = (field) => (e) => {
    this.setState({ [field]: e.target.value || undefined });
  };

  submit = () => {
    const developmentid = this.props.developmentId;

    const { privacy, other, save, ...user } = this.state;

    if (!user.title && other) {
      user.title = other;
    }

    if (save) {
      cookie.save('user-cache', user);
    }

    this.props.onSubmit({
      ...user,
      developmentid,
      privacy,
    });
  };

  componentDidMount() {
    const user = cookie.load('user-cache');
    if (user) {
      this.setState(user);
    }
  }

  privacyChange = () => {
    this.setState((prevState) => ({ privacy: !prevState.privacy }));
  };

  saveChange = () => {
    this.setState((prevState) => ({ save: !prevState.save }));
  };

  render() {
    return (
      <Modal
        isOpen
        style={{ overlay: { zIndex: 100 }, content: { maxWidth: 600, margin: '0 auto' } }}
      >
        <h2>Register Interest in {this.props.development}</h2>

        {this.props.alreadySubmitted ? (
          <p>
            You have already registered your interest in this property. We will let you know when it
            becomes available using the contact details you provided.
          </p>
        ) : (
          <p>
            {this.props.error && (
              <div className="alert alert-danger">
                An error occurred while registering interest:
                <br />
                {this.props.error}
              </div>
            )}
            <form action="" style={{ color: 'black' }}>
              <div className="form-group">
                <label htmlFor="title">Title *</label>
                <select
                  defaultValue={-1}
                  className="form-control"
                  autoComplete="honorific-prefix"
                  name="title"
                  id="title"
                  value={this.state.title}
                  onChange={this.handleChange('title')}
                >
                  <option value={-1} disabled>
                    Select
                  </option>
                  <option value="Mr">Mr</option>
                  <option value="Mrs">Mrs</option>
                  <option value="Miss">Miss</option>
                  <option value="Ms">Ms</option>
                  <option value="Dr">Dr</option>
                  <option value="other">Other</option>
                </select>
                {this.state.title === 'other' && (
                  <input
                    type="text"
                    className="form-control"
                    autoComplete="honorific-prefix"
                    placeholder="Other Title"
                    onChange={this.handleChange('other')}
                    value={this.state.other}
                  />
                )}
              </div>

              <div className="form-group">
                <label htmlFor="first_name">First Name *</label>
                <input
                  type="text"
                  id="first_name"
                  className="form-control"
                  autoComplete="given-name"
                  placeholder="First Name"
                  onChange={this.handleChange('firstname')}
                  value={this.state.firstname}
                />
              </div>
              <div className="form-group">
                <label htmlFor="">Last Name *</label>
                <input
                  type="text"
                  className="form-control"
                  autoComplete="family-name"
                  placeholder="Last Name"
                  onChange={this.handleChange('lastname')}
                  value={this.state.lastname}
                />
              </div>
              <div className="form-group">
                <label htmlFor="">Email *</label>
                <input
                  type="email"
                  className="form-control"
                  autoComplete="email"
                  placeholder="Email"
                  onChange={this.handleChange('email')}
                  value={this.state.email}
                />
              </div>
              <div className="form-group">
                <label htmlFor="">Phone Number</label>
                <input
                  type="text"
                  className="form-control"
                  autoComplete="tel"
                  placeholder="Phone"
                  onChange={this.handleChange('phone')}
                  value={this.state.phone}
                />
              </div>
              <div className="form-group">
                <input
                  id="save"
                  type="checkbox"
                  checked={this.state.save}
                  onChange={this.saveChange}
                />
                <label htmlFor="save" style={{ marginLeft: 8 }}>
                  Save details on this computer to use when submitting other forms
                </label>
              </div>
              <div className="form-group">
                <input
                  id="privacy"
                  type="checkbox"
                  checked={this.state.privacy}
                  onChange={this.privacyChange}
                />
                <label htmlFor="privacy" style={{ marginLeft: 8 }}>
                  Confirm you have read our{' '}
                  <Link to="/privacy" target="_blank" className="text-primary">
                    Privacy Policy
                  </Link>{' '}
                  *
                </label>
              </div>
            </form>
          </p>
        )}

        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <button type="button" className="btn btn-default" onClick={this.props.onClose}>
            Close
          </button>
          {!this.props.alreadySubmitted && (
            <button
              type="button"
              className="btn btn-primary"
              onClick={this.submit}
              disabled={this.props.loading}
            >
              Submit
            </button>
          )}
        </div>
      </Modal>
    );
  }
}
